class Mdfe {
  get model () {
    return {
    };
  }
  get validations () {
    return {};
  }
  get validationsErrors () {
    return {};
  }
}

export default new Mdfe();
